// extracted by mini-css-extract-plugin
export default {"page":"GR","heading":"HR","subheading":"IR","flavorbox":"JR","inner":"KR","image":"LR","label":"MR","flavorselect":"NR","arrow":"OR","flavorswrap":"PR","flavorsheader":"QR","flavorsnav":"RR","flavorsinner":"SR","cancelbtn":"TR","flavorsbottom":"UR","retakebtn":"VR","continueBtn":"WR","drawerinner":"XR","videowrap":"YR","flavorsbottomnav":"ZR"};
    if(module.hot) {
      // 1713996749114
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  